import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Analytics } from "@vercel/analytics/react"
// import { TooltipProvider } from './components/elements/ui/tooltip';
import { TooltipProvider } from './components/ui/tooltip';

import App from './App';
import './index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Failed to find root element');
}

const root = createRoot(container);

// Enhanced error boundary for both development and production
window.onerror = (message, source, lineno, colno, error) => {
  // Convert error object to string representation
  const errorDetails = error?.toString() || message;
  console.error('Global error:', {
    message: errorDetails,
    source,
    lineno,
    colno
  });
};

window.addEventListener('unhandledrejection', (event) => {
  // Ensure we're handling promise rejections properly
  const errorDetails = event.reason?.toString() || 'Unknown promise rejection';
  console.error('Unhandled promise rejection:', errorDetails);
});

root.render(
  <StrictMode>
    <TooltipProvider>
      <App />
      <Analytics />
    </TooltipProvider>
  </StrictMode >
);
